module.exports = __webpack_public_path__ + "static/img/products-white.c31ec23.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/sidebar/products-white.svg
// module id = 619
// module chunks = 2